import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(new LanguageDetector(null, { lookupLocalStorage: 'i18n-lang' }))
  .use(initReactI18next)
  .init({
    ns: ['common', 'errors', 'validation'],
    lng: 'ru',
    fallbackLng: 'ru',
    debug: !!import.meta.env.__DEV__,

    interpolation: {
      escapeValue: false,
    },
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
